import { PostWithToken, GetWithTokenParams, Get } from "../lib/request";

/**
 * Check if a member is registered by phone number.
 * @param {string} phone 
 */
export const checkMemberApi = (phone) => {
  return GetWithTokenParams("/v2/admin/loyalty/check-member", { phone });
};

/**
 * Register a student temporarily with pending verification status.
 * @param {object} data { name, student_id, phone }
 */
export const tempRegisterApi = (data) => {
  return PostWithToken("/v2/admin/loyalty/temp-register", data);
};

/**
 * Award points to a student.
 * @param {object} data { user_id, amount, pos_ref }
 */
export const earnPointsApi = (data) => {
  return PostWithToken("/v2/admin/loyalty/earn", data);
};

/**
 * Redeem points for a verified student.
 * @param {object} data { user_id, points, amount_rm, pos_ref }
 */
export const redeemPointsApi = (data) => {
  return PostWithToken("/v2/admin/loyalty/redeem", data);
};

/**
 * Fetch loyalty configs (e.g. EarnPoint and RedeemPoint rate).
 */
export const getLoyaltyConfigApi = () => {
  return Get("/v2/website/loyalty/config");
};

/**
 * Fetch loyalty profiles for superadmin.
 */
export const getLoyaltyProfilesApi = (params) => {
  return GetWithTokenParams("/v2/admin/loyalty/profiles", params);
};

/**
 * Fetch transaction history for a specific loyalty profile.
 */
export const getLoyaltyProfileHistoryApi = (consumerId) => {
  return GetWithTokenParams(`/v2/admin/loyalty/profiles/${consumerId}/history`);
};

